import {remote} from '../constants/environment';
import {IStandardServiceResponse} from '../interfaces/services/standard-service.interface';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {defaultHeaders} from './headers';
import {IFeePaymentProof} from '../interfaces/dtos/fee-payment-proof.interface';

export const postFeePaymentProof = async (
  paymentProof: IFeePaymentProof,
  token: string,
): Promise<IStandardServiceResponse> => {
  const handleResponse = async (response: Response) => {
    if (response.status === 200) {
      const data = await response.json();
      if (data.success && data.payload) {
        return {
          success: true,
          payload: {},
        };
      } else {
        return {
          success: false,
          payload: {},
        };
      }
    }
  };

  const remoteURI = remote.getFeeSendProofUri();

  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'POST',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
        body: JSON.stringify({
          payload: paymentProof,
        }),
      });
    },
    handleResponse,
    remoteURI,
  )) as IStandardServiceResponse;
};
